/**
 * New TokenTypes are to be added to the end of the list. Do not change the order.
 * @codegen
 */
export var AuthTokenType;
(function (AuthTokenType) {
    AuthTokenType[AuthTokenType["EditorLowPrivilege"] = 0] = "EditorLowPrivilege";
    AuthTokenType[AuthTokenType["AugLoopLowPrivilege"] = 1] = "AugLoopLowPrivilege";
    AuthTokenType[AuthTokenType["Anonymous"] = 2] = "Anonymous";
    AuthTokenType[AuthTokenType["ClientAssertion"] = 3] = "ClientAssertion";
    AuthTokenType[AuthTokenType["ClientAssertionV2"] = 4] = "ClientAssertionV2";
    AuthTokenType[AuthTokenType["AutoClpLowPrivilege"] = 5] = "AutoClpLowPrivilege";
    AuthTokenType[AuthTokenType["AutoClpAppOnlyLowPrivilege"] = 6] = "AutoClpAppOnlyLowPrivilege";
    AuthTokenType[AuthTokenType["Substrate"] = 7] = "Substrate";
    AuthTokenType[AuthTokenType["WacUserInfo"] = 8] = "WacUserInfo";
    AuthTokenType[AuthTokenType["OwaExchange"] = 9] = "OwaExchange";
    AuthTokenType[AuthTokenType["SmartCompose"] = 10] = "SmartCompose";
    AuthTokenType[AuthTokenType["WritingAnalyticsLowPrivilege"] = 11] = "WritingAnalyticsLowPrivilege";
    AuthTokenType[AuthTokenType["DWEngineLowPrivilege"] = 12] = "DWEngineLowPrivilege";
    AuthTokenType[AuthTokenType["SubstrateApp"] = 13] = "SubstrateApp";
    AuthTokenType[AuthTokenType["CortanaAppPop"] = 14] = "CortanaAppPop";
    AuthTokenType[AuthTokenType["OfficeAppsAppOnly"] = 15] = "OfficeAppsAppOnly";
    AuthTokenType[AuthTokenType["PPTFrontdoorAppPop"] = 16] = "PPTFrontdoorAppPop";
    AuthTokenType[AuthTokenType["EditorAppOnlyLowPrivilege"] = 17] = "EditorAppOnlyLowPrivilege";
    AuthTokenType[AuthTokenType["AugLoopApp"] = 18] = "AugLoopApp";
    AuthTokenType[AuthTokenType["MeetingIntelligenceApp"] = 19] = "MeetingIntelligenceApp";
    AuthTokenType[AuthTokenType["GraphApp"] = 20] = "GraphApp";
    AuthTokenType[AuthTokenType["IceServicesApp"] = 21] = "IceServicesApp";
    /**
     * @deprecated Use MSI auth for Azure Maps resources.
     */
    AuthTokenType[AuthTokenType["AzureMapsApp"] = 22] = "AzureMapsApp";
    AuthTokenType[AuthTokenType["SpoApp"] = 23] = "SpoApp";
    AuthTokenType[AuthTokenType["OneDrive"] = 24] = "OneDrive";
    AuthTokenType[AuthTokenType["GoogleDrive"] = 25] = "GoogleDrive";
    AuthTokenType[AuthTokenType["GettyApp"] = 26] = "GettyApp";
    AuthTokenType[AuthTokenType["Dropbox"] = 27] = "Dropbox";
    AuthTokenType[AuthTokenType["GooglePhotos"] = 28] = "GooglePhotos";
    AuthTokenType[AuthTokenType["EditorApp"] = 29] = "EditorApp";
    AuthTokenType[AuthTokenType["AmazonKindle"] = 30] = "AmazonKindle";
    AuthTokenType[AuthTokenType["ShredderApp"] = 31] = "ShredderApp";
    AuthTokenType[AuthTokenType["FormsLowPrivilege"] = 32] = "FormsLowPrivilege";
    AuthTokenType[AuthTokenType["VivaSalesLowPrivilege"] = 33] = "VivaSalesLowPrivilege";
    /**
     * @deprecated Use ShredderApp instead
     */
    AuthTokenType[AuthTokenType["IntentSvcApp"] = 34] = "IntentSvcApp";
    AuthTokenType[AuthTokenType["DcgLowPrivilege"] = 35] = "DcgLowPrivilege";
    AuthTokenType[AuthTokenType["CSALowPrivilege"] = 36] = "CSALowPrivilege";
    AuthTokenType[AuthTokenType["ConsumerSydneyLowPrivilege"] = 37] = "ConsumerSydneyLowPrivilege";
    AuthTokenType[AuthTokenType["CompliantSydneyApp"] = 38] = "CompliantSydneyApp";
    AuthTokenType[AuthTokenType["M365AdminApp"] = 39] = "M365AdminApp";
    AuthTokenType[AuthTokenType["MeetingArtifactsServiceLowPrivilege"] = 40] = "MeetingArtifactsServiceLowPrivilege";
    AuthTokenType[AuthTokenType["AlchemyApp"] = 41] = "AlchemyApp";
    AuthTokenType[AuthTokenType["M365Admin"] = 42] = "M365Admin";
    AuthTokenType[AuthTokenType["ConsumerShellApp"] = 43] = "ConsumerShellApp";
    AuthTokenType[AuthTokenType["PowerQueryLowPrivilege"] = 44] = "PowerQueryLowPrivilege";
    /**
     * @deprecated Do not use
     */
    AuthTokenType[AuthTokenType["CIIApp"] = 45] = "CIIApp";
    AuthTokenType[AuthTokenType["ConsumerShell"] = 46] = "ConsumerShell";
    AuthTokenType[AuthTokenType["AssistCopilotLowPrivilege"] = 47] = "AssistCopilotLowPrivilege";
    AuthTokenType[AuthTokenType["Pva"] = 48] = "Pva";
    AuthTokenType[AuthTokenType["TeamsCopilotServiceLowPrivilege"] = 49] = "TeamsCopilotServiceLowPrivilege";
    AuthTokenType[AuthTokenType["CallAnalytics"] = 50] = "CallAnalytics";
    AuthTokenType[AuthTokenType["IncomingPFT"] = 51] = "IncomingPFT";
    AuthTokenType[AuthTokenType["GraphExchange"] = 52] = "GraphExchange";
    AuthTokenType[AuthTokenType["EXOAdmin"] = 53] = "EXOAdmin";
    AuthTokenType[AuthTokenType["InsightsServicesLowPrivilege"] = 54] = "InsightsServicesLowPrivilege";
    /**
     * @deprecated Use VivaLearningLowPrivilege instead
     */
    AuthTokenType[AuthTokenType["VivaServicesLowPrivilege"] = 55] = "VivaServicesLowPrivilege";
    AuthTokenType[AuthTokenType["EcsAppOnly"] = 56] = "EcsAppOnly";
    AuthTokenType[AuthTokenType["ShredderLowPrivilege"] = 57] = "ShredderLowPrivilege";
    AuthTokenType[AuthTokenType["SpoLowPrivilege"] = 58] = "SpoLowPrivilege";
    AuthTokenType[AuthTokenType["PromptValidationApp"] = 59] = "PromptValidationApp";
    AuthTokenType[AuthTokenType["CompliantSydneyLowPrivilege"] = 60] = "CompliantSydneyLowPrivilege";
    AuthTokenType[AuthTokenType["SubstrateTenantFeedbackApp"] = 61] = "SubstrateTenantFeedbackApp";
    AuthTokenType[AuthTokenType["MonitoringPlatform"] = 62] = "MonitoringPlatform";
    AuthTokenType[AuthTokenType["YammerLowPrivilege"] = 63] = "YammerLowPrivilege";
    AuthTokenType[AuthTokenType["VivaLearningLowPrivilege"] = 64] = "VivaLearningLowPrivilege";
    AuthTokenType[AuthTokenType["VivaInsightsLowPrivilege"] = 65] = "VivaInsightsLowPrivilege";
    AuthTokenType[AuthTokenType["ClientAugLoopApp"] = 66] = "ClientAugLoopApp";
    AuthTokenType[AuthTokenType["AssistAuthLowPrivilege"] = 67] = "AssistAuthLowPrivilege";
    AuthTokenType[AuthTokenType["VivaLearningSearchPreProdLowPrivilege"] = 68] = "VivaLearningSearchPreProdLowPrivilege";
    AuthTokenType[AuthTokenType["SubstrateSearchApp"] = 69] = "SubstrateSearchApp";
    AuthTokenType[AuthTokenType["SparkContentPlatformLowPrivilege"] = 70] = "SparkContentPlatformLowPrivilege";
    AuthTokenType[AuthTokenType["SparkContentPlatformPopApp"] = 71] = "SparkContentPlatformPopApp";
    AuthTokenType[AuthTokenType["ConsumerSydneyApp"] = 72] = "ConsumerSydneyApp";
    AuthTokenType[AuthTokenType["BusinessAssistAuthLowPrivilege"] = 73] = "BusinessAssistAuthLowPrivilege";
    AuthTokenType[AuthTokenType["AzureResourceManager"] = 74] = "AzureResourceManager";
    AuthTokenType[AuthTokenType["AlchemyPortal"] = 75] = "AlchemyPortal";
    AuthTokenType[AuthTokenType["VivaUserSkillsApp"] = 76] = "VivaUserSkillsApp";
    AuthTokenType[AuthTokenType["VivaEngageAppPop"] = 77] = "VivaEngageAppPop";
    AuthTokenType[AuthTokenType["SubstrateAppOnly"] = 78] = "SubstrateAppOnly";
    AuthTokenType[AuthTokenType["PowerAutomateFlowCreationLowPrivilege"] = 79] = "PowerAutomateFlowCreationLowPrivilege";
    AuthTokenType[AuthTokenType["PowerAutomateConnectionCreationLowPrivilege"] = 80] = "PowerAutomateConnectionCreationLowPrivilege";
    AuthTokenType[AuthTokenType["PowerAutomateAuthorizeConnectionLowPrivilege"] = 81] = "PowerAutomateAuthorizeConnectionLowPrivilege";
    AuthTokenType[AuthTokenType["TCAAppPop"] = 82] = "TCAAppPop";
    AuthTokenType[AuthTokenType["BusinessAssistAuthAppPop"] = 83] = "BusinessAssistAuthAppPop";
    AuthTokenType[AuthTokenType["HolmesApp"] = 84] = "HolmesApp";
    AuthTokenType[AuthTokenType["GraphAppOnly"] = 85] = "GraphAppOnly";
    AuthTokenType[AuthTokenType["SimsApp"] = 86] = "SimsApp";
    /**
     * @deprecated Use VivaOrgInsightsAppPop instead
     */
    AuthTokenType[AuthTokenType["VivaOrgInsightsLowPrivilege"] = 87] = "VivaOrgInsightsLowPrivilege";
    AuthTokenType[AuthTokenType["VivaGoalsAppPop"] = 88] = "VivaGoalsAppPop";
    AuthTokenType[AuthTokenType["GCBotAppPop"] = 89] = "GCBotAppPop";
    AuthTokenType[AuthTokenType["ShredderV2App"] = 90] = "ShredderV2App";
    AuthTokenType[AuthTokenType["ShredderV2LowPrivilege"] = 91] = "ShredderV2LowPrivilege";
    AuthTokenType[AuthTokenType["AmplifyProfileService"] = 92] = "AmplifyProfileService";
    AuthTokenType[AuthTokenType["AzureDevopsLowPrivilege"] = 93] = "AzureDevopsLowPrivilege";
    AuthTokenType[AuthTokenType["CommuteServices"] = 94] = "CommuteServices";
    AuthTokenType[AuthTokenType["GCBotAppOnly"] = 95] = "GCBotAppOnly";
    AuthTokenType[AuthTokenType["TCAAppOnly"] = 96] = "TCAAppOnly";
    AuthTokenType[AuthTokenType["MavenAgentLowPrivilege"] = 97] = "MavenAgentLowPrivilege";
    AuthTokenType[AuthTokenType["VivaOrgInsightsAppPop"] = 98] = "VivaOrgInsightsAppPop";
    AuthTokenType[AuthTokenType["EduAssignmentsPftAtPop"] = 99] = "EduAssignmentsPftAtPop";
    AuthTokenType[AuthTokenType["AugloopAppPop"] = 100] = "AugloopAppPop";
    AuthTokenType[AuthTokenType["OneNoteLowPrivilege"] = 101] = "OneNoteLowPrivilege";
    AuthTokenType[AuthTokenType["TeamsAuthzSvcAppPop"] = 102] = "TeamsAuthzSvcAppPop";
    AuthTokenType[AuthTokenType["LoopAppPop"] = 103] = "LoopAppPop";
    AuthTokenType[AuthTokenType["LoopAppOnly"] = 104] = "LoopAppOnly";
    AuthTokenType[AuthTokenType["BapLowPrivilege"] = 105] = "BapLowPrivilege";
    AuthTokenType[AuthTokenType["IC3AppPop"] = 106] = "IC3AppPop";
    AuthTokenType[AuthTokenType["PowerPlatformApiGateway"] = 107] = "PowerPlatformApiGateway";
    AuthTokenType[AuthTokenType["OdspNotifyAppPop"] = 108] = "OdspNotifyAppPop";
    AuthTokenType[AuthTokenType["MIPSyncService"] = 109] = "MIPSyncService";
    AuthTokenType[AuthTokenType["RightsManagementServices"] = 110] = "RightsManagementServices";
    AuthTokenType[AuthTokenType["TCAV2AppPop"] = 111] = "TCAV2AppPop";
    AuthTokenType[AuthTokenType["SubstrateLLMLowPrivilege"] = 112] = "SubstrateLLMLowPrivilege";
    AuthTokenType[AuthTokenType["SubstrateSearchLowPrivilege"] = 113] = "SubstrateSearchLowPrivilege";
    AuthTokenType[AuthTokenType["CloudPolicyServiceAppPop"] = 114] = "CloudPolicyServiceAppPop";
    AuthTokenType[AuthTokenType["TCAV2LowPrivilege"] = 115] = "TCAV2LowPrivilege";
    AuthTokenType[AuthTokenType["AiHubServicesAppPop"] = 116] = "AiHubServicesAppPop";
    AuthTokenType[AuthTokenType["TMRAppOnly"] = 117] = "TMRAppOnly";
    AuthTokenType[AuthTokenType["PacmanAppPop"] = 118] = "PacmanAppPop";
    AuthTokenType[AuthTokenType["AugloopAlternativeIdentity"] = 119] = "AugloopAlternativeIdentity";
    AuthTokenType[AuthTokenType["SpoAppOnly"] = 120] = "SpoAppOnly";
    AuthTokenType[AuthTokenType["DataverseLowPrivilege"] = 121] = "DataverseLowPrivilege";
    AuthTokenType[AuthTokenType["SubstrateLLMApp"] = 122] = "SubstrateLLMApp";
    AuthTokenType[AuthTokenType["SimsAppOnly"] = 123] = "SimsAppOnly";
    AuthTokenType[AuthTokenType["PythonService"] = 124] = "PythonService";
    AuthTokenType[AuthTokenType["PythonServiceAppOnly"] = 125] = "PythonServiceAppOnly";
    AuthTokenType[AuthTokenType["DesignerAppServiceLowPrivilege"] = 126] = "DesignerAppServiceLowPrivilege";
    AuthTokenType[AuthTokenType["DesignerAppServiceAppPop"] = 127] = "DesignerAppServiceAppPop";
    AuthTokenType[AuthTokenType["AmplifyProfileServiceAppOnly"] = 128] = "AmplifyProfileServiceAppOnly";
    AuthTokenType[AuthTokenType["MARSAppPop"] = 129] = "MARSAppPop";
    AuthTokenType[AuthTokenType["PlannerAppPop"] = 130] = "PlannerAppPop";
    AuthTokenType[AuthTokenType["BingForBusinessLowPrivilege"] = 131] = "BingForBusinessLowPrivilege";
    AuthTokenType[AuthTokenType["OLS"] = 132] = "OLS";
    AuthTokenType[AuthTokenType["OLSAppPop"] = 133] = "OLSAppPop";
    AuthTokenType[AuthTokenType["GCS"] = 134] = "GCS";
    AuthTokenType[AuthTokenType["AugLoopConsumer"] = 135] = "AugLoopConsumer";
    AuthTokenType[AuthTokenType["ContentValidationServiceAppOnly"] = 136] = "ContentValidationServiceAppOnly";
    AuthTokenType[AuthTokenType["FabricLowPrivilege"] = 137] = "FabricLowPrivilege";
    AuthTokenType[AuthTokenType["FeatureAccessManagementAppPop"] = 138] = "FeatureAccessManagementAppPop";
})(AuthTokenType || (AuthTokenType = {}));
export var UserType;
(function (UserType) {
    UserType[UserType["Unknown"] = 0] = "Unknown";
    UserType[UserType["Consumer"] = 1] = "Consumer";
    UserType[UserType["Enterprise"] = 2] = "Enterprise";
})(UserType || (UserType = {}));
export var UserDataBoundaryType;
(function (UserDataBoundaryType) {
    UserDataBoundaryType[UserDataBoundaryType["Default"] = 0] = "Default";
    UserDataBoundaryType[UserDataBoundaryType["EDPSCompliant"] = 1] = "EDPSCompliant";
})(UserDataBoundaryType || (UserDataBoundaryType = {}));
/**
 * OAuth 2.0 authorization grant flow
 */
export var OAuth2GrantFlow;
(function (OAuth2GrantFlow) {
    OAuth2GrantFlow["AuthorizationCode"] = "authorization_code";
    OAuth2GrantFlow["ClientCredentials"] = "client_credentials";
    OAuth2GrantFlow["RefreshToken"] = "refresh_token";
})(OAuth2GrantFlow || (OAuth2GrantFlow = {}));
/**
 * OAuth 2.0 V2 logged in status
 */
export var OAuth2V2LoginStatus;
(function (OAuth2V2LoginStatus) {
    OAuth2V2LoginStatus[OAuth2V2LoginStatus["LoggedIn"] = 0] = "LoggedIn";
    OAuth2V2LoginStatus[OAuth2V2LoginStatus["LoggedOut"] = 1] = "LoggedOut";
})(OAuth2V2LoginStatus || (OAuth2V2LoginStatus = {}));
//# sourceMappingURL=authTypes.js.map